var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"a-flex a-ai-c a-jc-c a-bg-_F85A5B a-c-_fff a-fw-500",style:({
    width: _vm.width + 'rpx',
    height: _vm.height + 'rpx',
    lineHeight: _vm.height + 'rpx',
    borderRadius: _vm.borderRadius + 'rpx',
    fontSize: _vm.fontSize + 'rpx',
  })},[_vm._v(_vm._s(_vm.btnText))])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }